import { render, staticRenderFns } from "./NthNationalAssemblyPage.vue?vue&type=template&id=8d86bec2&scoped=true"
import script from "./NthNationalAssemblyPage.vue?vue&type=script&lang=js"
export * from "./NthNationalAssemblyPage.vue?vue&type=script&lang=js"
import style0 from "./NthNationalAssemblyPage.vue?vue&type=style&index=0&id=8d86bec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d86bec2",
  null
  
)

export default component.exports